import type { PackingSlip, PackingSlipItemCollection } from '@/types/Models/PackingSlip'
import { BaseProxy, type ProxyMethods } from '@/proxies/Proxy'

export default class PackingSlipProxy extends BaseProxy implements ProxyMethods<PackingSlip> {
  public endpoint = 'packing-slips'

  getItems(id: string): Promise<PackingSlipItemCollection> {
    return this.submit('get', `/${this.endpoint}/${id}/items`)
  }

  removeItems(id: string, items: string[]): Promise<any> {
    return this.submit('post', `/${this.endpoint}/${id}/remove-items`, { items })
  }
}
